import { Box } from '@cdl/heartbeat-react';
import { useSelector } from 'react-redux';
import { roundedDurationSelector } from '../ecg/selectors/ecg.selectors';
import { MinutePlot } from '../plot/components/MinutePlot';
import { PlotContainer } from '../plot/components/PlotContainer';
import { RestingPlot } from './RestingPlot';
import {
  RESTING_ONSET_ON_SCREEN,
  RESTING_OFFSET_ON_SCREEN,
} from './resting.util';

export const Resting: React.FC = () => {
  const duration = useSelector(roundedDurationSelector);
  return (
    <Box>
      <PlotContainer position='relative' data-testid='resting-plot'>
        <RestingPlot />
        <MinutePlot
          onset={RESTING_ONSET_ON_SCREEN}
          offset={RESTING_OFFSET_ON_SCREEN}
          duration={duration}
        />
      </PlotContainer>
    </Box>
  );
};
